<template>
  <b-modal :id="modalId" :title="title" hide-footer no-close-on-backdrop>
    <b-tabs content-class="mt-3" v-if="selectedUser">
      <b-tab title="Profile" active>
        <div class="tab-box">
          <profile-row heading="NAME" :info="selectedUser.full_name" />
          <profile-row heading="EMAIL" :info="selectedUser.email" />
          <profile-row heading="ORGANIZATION" v-if="selectedOrganization" :info="selectedOrganization.name" />
          <profile-row heading="GROUP" v-if="selectedUser.group" :info="selectedUser.group.name" />
          <profile-row heading="ROLE" v-if="selectedUser.role" :info="selectedUser.role.name" />
          <profile-row heading="ACTIVATION" v-if="canEditUser && canActivateUser">
            <template v-slot:info-slot>
              <activation-toggle :activationStatus="selectedUser.is_active"
                :isLoading="isTogglingActivation"
                @toggleActivation="toggleActivation" />
            </template>
          </profile-row>
        </div>
      </b-tab>
      <b-tab title="Edit" v-if="canEditUser">
        <edit-user-form :user="selectedUser" @hasUpdate="hasUpdate" />
      </b-tab>
      <b-tab title="Move Group" v-if="canMoveGroup">
        <move-group-form :user="selectedUser" @hasUpdate="hasUpdate" />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import EditUserForm from '../Forms/EditUserForm.vue';
import MoveGroupForm from '../Forms/MoveGroupForm.vue';
import ProfileRow from '../ProfileRow.vue';
import ActivationToggle from '../Inputs/ActivationToggle.vue';
import config from '../../constants/config';
import { mapGetters } from 'vuex';

export default {
  name: 'UserModal',
  components: {
    EditUserForm,
    MoveGroupForm,
    ProfileRow,
    ActivationToggle
  },
  data() {
    return {
      isTogglingActivation: false
    }
  },
  created() {
    if (!this.roles) {
      this.$store.dispatch('user/fetchRoles');
    }
  },
  methods: {
    async toggleActivation() {
      this.isTogglingActivation = true;

      const success = await this.$store.dispatch('user/toggleActivation', this.selectedUser);
      if (success) {
        this.hasUpdate();
      }

      this.isTogglingActivation = false;
    },
    hasUpdate() {
      this.$emit('hasUpdate');
    }
  },
  computed: {
    ...mapGetters('user', ['roles', 'selectedUser', 'user',
      'isSuperUser', 'isStaffUser', 'isPartner', 'isManager']),
    ...mapGetters('organization', ['selectedOrganization']),
    modalId() {
      return config.USER_MODAL_ID;
    },
    title() {
      return this.selectedUser ? this.selectedUser.full_name : "";
    },
    selectedRole() {
      return this.selectedUser ? this.selectedUser.role.id : null;
    },
    canEditUser() {
      return this.selectedUser.id != this.user.id &&
        (this.isSuperUser ||
        this.roles.map((role) => { return role.id }).includes(this.selectedRole));
    },
    canActivateUser() {
      return this.selectedUser.is_confirmed;
    },
    canMoveGroup() {
      return this.selectedUser.id != this.user.id &&
        (this.isSuperUser || this.isStaffUser || this.isPartner || this.isManager);
    }
  }
};
</script>
